import React from "react";
import deIcon from "assets/icons/languages/de-de.svg";
import atIcon from "assets/icons/languages/de-at.svg";
import gbIcon from "assets/icons/languages/en-gb.svg";
import usIcon from "assets/icons/languages/en-us.svg";
import frIcon from "assets/icons/languages/fr-fr.svg";
import esIcon from "assets/icons/languages/es-419.svg";
import itIcon from "assets/icons/languages/it-it.svg";
import jaIcon from "assets/icons/languages/ja-jp.svg";
import ptIcon from "assets/icons/languages/pt-br.svg";
import trIcon from "assets/icons/languages/tr-tr.svg";
import zhIcon from "assets/icons/languages/zh-cn.svg";

export interface TTSLanguage {
  name: string;
  voices: string[];
}

export interface TTS {
  name: string;
  languages: TTSLanguage[];
  description: string;
}

export interface TTSDataInEnv {
  envName: string;
  data: TTS[];
}

export type TTSLanguageType =
  | "en-us"
  | "en-gb"
  | "de-de"
  | "de-at"
  | "fr-fr"
  | "es-419"
  | "it-it"
  | "ja-jp"
  | "pt-br"
  | "tr-tr"
  | "zh-cn";

export const TTSLanguageMapping: Record<string, string> = {
  "en-us": "English (US)",
  "en-gb": "English (GB)",
  "de-de": "German (DE)",
  "de-at": "German (AT)",
  "fr-fr": "French",
  "es-419": "Spanish (LATAM)",
  "it-it": "Italian",
  "ja-jp": "Japanese",
  "pt-br": "Brazilian Portuguese",
  "tr-tr": "Turkish",
  "zh-cn": "Mandarin Chinese",
};

export interface TTSInstance {
  selectedEnv: string;
  selectedDeployment: string;
  selectedSampleRate: string;
  selectedLanguage: string;
  selectedVoice: string;
}

export interface PresetValueProps {
  value: string;
  label: string;
}

export interface EachContourValueProps {
  time: number;
  value: number;
}

export interface SelectedContourValueProps {
  index: number;
  data: EachContourValueProps;
}

export interface CheckInvalidNestedTagsProps {
  shouldShowError: boolean;
  isWrappedWithSameTag: boolean;
  isWrappedWithSayAsTag: boolean;
}

export interface LanguageProps {
  value: string;
  label: string;
}

export enum PlayStatus {
  InActive = "inactive", // default
  InProgress = "inprogress", // when the play is clicked
  Ready = "ready", // after the selected text is stored in an atom
}

export type EditorButtonStyles = {
  padding?: string;
  margin?: string;
  cursor?: "default" | "pointer";
};

export type PhonemeTooltipMap = {
  [key: string]: React.JSX.Element;
};

export const TTSLanguageIconMapping = {
  "en-us": usIcon,
  "en-gb": gbIcon,
  "de-de": deIcon,
  "de-at": atIcon,
  "fr-fr": frIcon,
  "es-419": esIcon,
  "it-it": itIcon,
  "ja-jp": jaIcon,
  "pt-br": ptIcon,
  "tr-tr": trIcon,
  "zh-cn": zhIcon,
};
